$('.js-main-popup').each((index, element) => {
	let $component = $(element);
	let $closeButton = $component.find('.js-main-popup-button');
	let $page = $component.closest('.page');
	let $header = $page.find('.js-header');
	let $footer = $page.find('.js-footer');

	$closeButton.on('click', () => {
		$component.fadeOut(300);
		$('.circle-item, .small-circle-item').addClass('not-opacity');

		setTimeout(() => {
			$footer.trigger('footer:show');
			$header.addClass('active');
		}, 300);
	});
});
